import { assetUtils } from '@zen/common-utils';
import PATHS from '../paths';
/**
 * Redirect to path page
 *
 * @param {Object} props
 * @param {string} props.path a PATHS constant
 * @param {string} props.base - base asset
 * @param {string} props.quote - quote asset
 * @returns {string}
 */
export function getRedirectTo({ path, base, quote }) {
  if (base || quote) {
    const baseFormatted = assetUtils.getAssetRepresentationId(base);
    const quoteFormatted = assetUtils.getAssetRepresentationId(quote);
    const redirectTo = encodeURIComponent(
      `${PATHS.ORDER_BOOK}?base=${baseFormatted}&quote=${quoteFormatted}`
    );
    return path + '?redirectTo=' + redirectTo;
  }
  return path;
}
